import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { datasetQueryKeys } from "./useDatasetsQuery";

export function useDeleteDatasets() {
  const { datasetService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<PromiseSettledResult<void>[], Error, string[]>({
    mutationFn: (datasetIds) =>
      Promise.allSettled(
        datasetIds.map((id) =>
          datasetService.deleteDataset(id, {
            resourceOwnerId: currentOrganization?.org_id,
          }),
        ),
      ),
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: datasetQueryKeys.lists(),
      });
    },
  });
}
